var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { camelizeKeys } from '../util';
// WebViewに送信できるコールバックハンドラー名
export const WebViewCallbackHandlers = {
    notificationSettingsChange: 'handle_notification_settings_change',
    registrationOpenBrowser: 'registration_open_browser',
    // ヘルスコネクトがインストールされていない -> インストール催促のダイアログを表示
    // ヘルスコネクトのPermissionに回答したことがない -> Permissionを表示
    // ヘルスコネクトのPermissionに回答済み(許可/拒否どちらであっても) -> ヘルスコネクトアプリを表示
    requestHealthConnectPermission: 'request_health_connect_permission',
    sendStepFromHealthConnect: 'send_step_from_health_connect',
    sendWeightAndFatBodyFromHealthConnect: 'send_weight_and_fat_body_from_health_connect',
    fbLogin: 'fb_login',
    requestDeviceNotificationPermission: 'request_device_notification_permission', // デバイスの通知許可ダイアログを表示する
    requestDeviceNotificationPermissionSettings: 'request_device_notification_permission_settings', // デバイスの通知許可設定ページを表示する
    loadNotificationSettings: 'load_notification_settings', // 通知設定を取得する
    requestCameraPermission: 'request_camera_permission', // カメラの許可
    openLeanBodyAppSetting: 'open_lean_body_app_setting', // アプリの設定を開く
};
// WebViewから受け取るイベント
export const WebViewEvents = {
    deviceNotificationPermission: 'webview_device_notification_permission',
};
export const callWebViewHandler = (handler, ...args) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const result = yield ((_a = window.flutter_inappwebview) === null || _a === void 0 ? void 0 : _a.callHandler(handler, ...args));
    return camelizeKeys(result);
});
